import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';

import OptionButton from './OptionButton';

const ExtraTimeButton = ({ clickHandler, a11yAttributes }) => {
    return (<OptionButton
        iconClass="fa fa-clock-o fa-fw"
        clickHandler={clickHandler}
        title={t('options.addExtraTimeTitle')}
        a11yAttributes={a11yAttributes}
    />);
};

ExtraTimeButton.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    a11yAttributes: PropTypes.object,
};

export default ExtraTimeButton;
